import type { FC } from 'react';
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AppContext from '../utils/appContext';

interface registeruserProps {
  refresh: () => void;
}

const RegisterUser: FC<registeruserProps> = ({ refresh }) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [phone, setPhone] = useState('');

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [roles, setRoles] = useState<Array<any>>([]);
  const [contacts, setContacts] = useState<Array<any>>([]);
  const [selectedRoles, setSelectedRoles] = useState<any>([]);
  const [selectedContact, setSelectedContact] = useState('');

  const context = useContext(AppContext);
  const navigate = useNavigate();
  const refreshList = () => {
    refresh();
  };
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    const access_levels = selectedRoles;
    const contact = selectedContact;
    const storedJWT = localStorage.getItem('jwt');

    if (storedJWT) {
      await fetch(process.env.REACT_APP_API_URL + '/register-user.php', {
        body: JSON.stringify({
          email,
          firstname,
          lastname,
          phone,
          access_levels,
          contact,
        }),
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + storedJWT,
        },
        method: 'POST',
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message == 'User registered successfully') {
            setSuccess(data.message);
            clearForm();
            refreshList();
          } else if (data.error == 'Email already exists') {
            setError('User already registered');
          }
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setError('Failed, try again');
          setLoading(false);
        });
    } else {
      console.log('not logged in');
      localStorage.clear();
      context?.updateLoginStatus(false);
      navigate('/login');
    }
  };

  const getRoles = async () => {
    const storedJWT = localStorage.getItem('jwt');
    await fetch(process.env.REACT_APP_API_URL + '/get-roles.php', {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: 'Bearer ' + storedJWT,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setRoles(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const getContacts = async () => {
    const storedJWT = localStorage.getItem('jwt');
    await fetch(process.env.REACT_APP_API_URL + '/get-contacts.php', {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: 'Bearer ' + storedJWT,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setContacts(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const clearForm = () => {
    setEmail('');
    setFirstname('');
    setLastname('');
    setPhone('');
    setSelectedRoles([]);
    setSelectedContact('');
  };
  useEffect(() => {
    getRoles();
    getContacts();
  }, []);

  return (
    <>
      <h2 className="mt-12 text-xl font-normal text-gray-900">
        Register a user
      </h2>

      <div className="max-w-full pr-5 md:mt-8 md:max-w-lg">
        <div className="py-8 bg-white md:shadow md:px-4 md:rounded-lg ">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="grid gap-5 md:grid-cols-2">
              <div>
                <label
                  htmlFor="firstname"
                  className="block text-sm font-medium text-gray-700"
                >
                  Firstname
                </label>
                <div className="mt-1">
                  <input
                    id="firstname"
                    name="firstname"
                    type="text"
                    required
                    value={firstname}
                    onChange={(event) => setFirstname(event.target.value)}
                    className="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-[#d3d3cd] focus:border-[#d3d3cd] sm:text-sm"
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="lastname"
                  className="block text-sm font-medium text-gray-700"
                >
                  Lastname
                </label>
                <div className="mt-1">
                  <input
                    id="lastname"
                    name="lastname"
                    type="text"
                    required
                    value={lastname}
                    onChange={(event) => setLastname(event.target.value)}
                    className="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-[#d3d3cd] focus:border-[#d3d3cd] sm:text-sm"
                  />
                </div>
              </div>
            </div>
            <div className="grid gap-5 md:grid-cols-2">
              <div>
                <label
                  htmlFor="firstname"
                  className="block text-sm font-medium text-gray-700"
                >
                  E-mail
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    autoComplete="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    className="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-[#d3d3cd] focus:border-[#d3d3cd] sm:text-sm"
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-700"
                >
                  Phone
                </label>
                <div className="mt-1">
                  <input
                    id="phone"
                    name="phone"
                    type="text"
                    required
                    value={phone}
                    onChange={(event) => setPhone(event.target.value)}
                    className="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-[#d3d3cd] focus:border-[#d3d3cd] sm:text-sm"
                  />
                </div>
              </div>
            </div>
            <div>
              <label
                htmlFor="role"
                className="block text-sm font-medium text-gray-700"
              >
                Role
              </label>
              <div className="mt-1">
                <select
                  id="roles"
                  name="roles"
                  required
                  multiple
                  value={selectedRoles}
                  onChange={(event) => {
                    // convert selected options to an array and update state
                    const selectedOptions = Array.from(
                      event.target.selectedOptions,
                      (option) => option.value
                    );
                    setSelectedRoles(selectedOptions);
                  }}
                  className={`text-default block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-[#d3d3cd] focus:border-[#d3d3cd] sm:text-sm`}
                >
                  <option disabled value="">
                    Select roles
                  </option>

                  {Array.isArray(roles) &&
                    roles.map((role) => (
                      <option key={role.access_level} value={role.access_level}>
                        {role.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div>
              <label
                htmlFor="contact"
                className="block text-sm font-medium text-gray-700"
              >
                Contact
              </label>
              <div className="mt-1">
                <select
                  id="contact"
                  name="contact"
                  required
                  value={selectedContact}
                  onChange={(event) => setSelectedContact(event.target.value)}
                  className={`text-default block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-[#d3d3cd] focus:border-[#d3d3cd] sm:text-sm`}
                >
                  <option disabled value="">
                    Select a contact
                  </option>
                  <option value="0">No contact</option>
                  {Array.isArray(contacts) &&
                    contacts.map((contact) => (
                      <option key={contact.ID} value={contact.ID}>
                        {contact.firstname} {contact.lastname} - {contact.email}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div>
              {loading ? (
                <div className="flex justify-center">
                  <svg
                    className="inline-blockmt-5 w-9 h-9 text-accent animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              ) : (
                <button
                  type="submit"
                  className="flex justify-center w-full px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-default hover:bg-[#d3d3cd] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#d3d3cd]"
                >
                  Register
                </button>
              )}
              <p className="mt-2 text-sm font-medium text-red-600">{error}</p>
              <p className="mt-2 text-sm font-medium text-green-600">
                {success}
              </p>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default RegisterUser;
